import React, { useEffect, useState } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import { env } from '../../config/env';

const PurchaseHistory = () => {
  const [chartData, setChartData] = useState([]);
  const [chartPeriod, setChartPeriod] = useState('2026');

  useEffect(() => {
    const fetchMonthlyData = async () => {
      try {
        const response = await fetch(`${env.API_URL}/market/solana/monthly`);
        const data = await response.json();
        // console.log(env.API_URL);
        // console.log(data);
        setChartData(data);
      } catch (err) {
        console.error('Erreur récupération données mensuelles Solana:', err);
      }
    };

    fetchMonthlyData();
  }, []);

  useEffect(() => {
    if (chartData.length > 0) {
      const startDate = new Date(chartData[0].date);
      const endDate = new Date(chartData[chartData.length - 1].date);
      
      const isMobile = window.innerWidth < 640;

      const period = isMobile
        ? `${startDate.getFullYear()} – ${endDate.getFullYear()}`
        : `${startDate.toLocaleString('en-US', { month: 'short', year: 'numeric' })} – ${endDate.toLocaleString('en-US', { month: 'short', year: 'numeric' })}`;

      setChartPeriod(period);
    }
  }, [chartData]);

  const renderCustomLegend = (props) => {
    const { payload } = props;
    return (
      <div
        style={{
          color: '#fff',
          paddingBottom: '10px',
          fontSize: '13px',
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
          gap: '20px' // espace entre légendes
        }}
      >
        {payload.map((entry, index) => (
          <span key={`item-${index}`} style={{ display: 'inline-flex', alignItems: 'center' }}>
            <svg width="10" height="10" style={{ marginRight: 6 }}>
              <circle cx="5" cy="5" r="5" fill={entry.color} />
            </svg>
            <span> {entry.value.toUpperCase().replace(/^SOL/, 'SOL ')} </span>
          </span>
        ))}
      </div>
    );
  };

  return (
    <section className="section_purchase-history">
      <div className="padding-global">
        <div className="container-large">
          <div className="text-align-center">
            <h1 className="line-height-1-2">
              Solana Purchase History{' '}
              {chartPeriod && <sup>{'('}{chartPeriod}{')'}</sup>}
            </h1>
          </div>
          <div className="spacer-3-5 spacer-mobile-2"></div>
          <div className="sol-price-history"
            style={{
              opacity: 1,
              overflowX: 'auto',
            }}
          >
            <div style={{ minWidth: 600 }} >
              <ResponsiveContainer width="100%" height={500}>
                <LineChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                  <XAxis
                    dataKey="date"
                    tickFormatter={(dateStr) => {
                      const date = new Date(dateStr);
                      const day = date.getDate();
                      // Affiche uniquement si c'est le 1er du mois
                      return day === 1 ? date.toLocaleString('en-US', { month: 'short' }) : '';
                    }}
                    interval={0} // Affiche tous les ticks (on les masque nous-mêmes si besoin)
                    minTickGap={15} // Ajuste automatiquement l'espacement minimal
                    tickLine={false}
                  />
                  <YAxis tickFormatter={(v) => `${v.toFixed(0)} €`} tickLine={false} />
                  <Legend
                    verticalAlign="top"
                    content={renderCustomLegend}
                  />
                  <Tooltip
                    content={({ label, payload }) => {
                      if (!payload || !payload.length) return null;

                      const date = new Date(label);
                      const formattedDate = date.toLocaleDateString('en-US', {
                        weekday: 'short',
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric',
                      });

                      const dataPoint = payload[0].payload;

                      return (
                        <div style={{ backgroundColor: '#000', padding: '12px', border: '1px solid #ccc' }}>
                          {/* Ligne vide */}


                          {/* Titre Token */}
                          {dataPoint.tokenPurchased && dataPoint.tokenPurchased > 0 && (
                            <div>
                              <div style={{ height: '10px' }}></div>
                              <p style={{ margin: 0, color: '#8affe4', fontWeight: 'bold', fontSize: '14px' }}>
                                SOLANA PURCHASE
                              </p>
                              <p style={{ margin: '10px 0 0', color: '#aaa' }}>
                                <strong>TOKEN PURCHASED:</strong>{' '}
                                <span style={{ color: '#fff' }}>{dataPoint.tokenPurchased.toLocaleString()} SOL</span>
                              </p>
                            </div>
                          )}

                          {/* Date */}
                          <p style={{ margin: '4px 0', color: '#aaa' }}>
                            <strong>DATE:</strong>{' '}
                            <span style={{ color: '#fff' }}>{formattedDate}</span>
                          </p>

                          {/* Price */}
                          <p style={{ margin: 0, color: '#aaa' }}>
                            <strong>SOL PRICE:</strong>{' '}
                            <span style={{ color: '#fff' }}>{payload[0].value.toLocaleString()} €</span>
                          </p>

                          {payload[0] && payload[0].payload.purchasedSolanaDate && (
                            <p style={{ margin: '4px 0', color: '#aaa' }}>
                              <strong>PURCHASED DATE:</strong>{' '}
                              <span style={{ color: '#fff' }}>
                                {new Date(payload[0].payload.purchasedSolanaDate).toLocaleDateString('en-US', {
                                  weekday: 'short',
                                  day: 'numeric',
                                  month: 'short',
                                  year: 'numeric',
                                })}
                              </span>
                            </p>
                          )}

                        </div>
                      );
                    }}
                  />
                  <Line type="linear" dataKey="solPrice" stroke="#7f00ff" strokeWidth={2} dot={false} />

                  <Line
                    type="linear"
                    dataKey="solPurchase"
                    stroke="#8affe4" // couleur pour la légende
                    strokeWidth={0}  // ligne invisible
                    dot={{ r: 5, fill: "#8affe4" }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default PurchaseHistory;